import { styled } from "@mui/material/styles";

const Root = styled("div")(({ theme }) => ({
  textAlign: "center",
  padding: "50px",
  margin: "0px 100px",
  [theme.breakpoints.down("md")]: {
    padding: "20px",
    margin: "0px 10px",
  },
}));
const Tittle = styled("p")(({ theme }) => ({
  color: "#FF0000",
  ///top right bottom left
  padding: "35px 0px 20px 0px",
  fontWeight: "bold",
  fontSize: "2.5rem",
  [theme.breakpoints.down("sm")]: {
    fontSize: "2rem",
  },
}));
const Container = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    padding: "8px",
  },
}));
const Column = styled("div")(({ theme }) => ({
  //   margin: "auto",
  marginBottom: "30px",
  borderRadius: "20px",
  padding: "15px",
  width: "100%",
  maxWidth: "50%",
  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
    margin: "auto",
  },
}));
const ColumnButtons = styled("div")(({ theme }) => ({
  margin: "auto",
  borderRadius: "20px",
  width: "250px",
  [theme.breakpoints.down("sm")]: {
    minHeight: "70px",
  },
}));
const Button = styled("button")(({ theme }) => ({
  marginTop: "35px",
  width: "100%",
  backgroundColor: "#FF0000",
  textAlign: "center",
  padding: "15px",
  borderRadius: "15px",
  border: "0px",
  color: "white",
  [theme.breakpoints.down("sm")]: {
    marginTop: "15px",
  },
  "&:hover": {
    backgroundColor: "#ffcdd2",
    opacity: [0.9, 0.8, 0.7],
    color: "black",
  },
  "&:focus": {
    outline: "0 !important",
  },
}));
const Helper = styled("p")((props) => ({
  textAlign: "center",
  paddingBottom: "15px",
  color: "#FF0000",
}));

export { Root, Tittle, Container, Column, ColumnButtons, Button, Helper };
